import  React, { useEffect, useRef, useState } from "react";
import './style.scss';
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getTheReadingRoom, cornerSectionOverview
} from "../actions";
import { getRouting, formDataGenerator } from "../../../../../utils/common";
import SocialShare from "../../../general/socials";
import cookie from 'react-cookies';

const TheReadingRoom = (props) => {
  const {
    getTheReadingRoom,
    theReadingRoomData,
    cornerOverviewList,
    cornerSectionOverview,
    location: { pathname },
  } = props;
  
  const [readingData, setReadingData] = useState();
  const [metaData, setmetaData] = useState();
  const [share, setShare] = useState(false);
  const [cardId, setCardId] = useState(-1);
  const [isDesktop, setIsDesktop] = useState(true);
  const [cornerOverviewTab, setcornerOverviewTab] = useState("");
  //dropdown start

  const [isOpendrop, setIsOpendrop] = useState(false);
  const dropdownheadRef = useRef(null);

  const toggleDropDownHead = () => {
    setIsOpendrop(!isOpendrop);
  };

  const handleClickOutHead = (event) => {
    if (dropdownheadRef.current && !dropdownheadRef.current.contains(event.target)) {
      setIsOpendrop(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutHead);
    return () => {
      document.removeEventListener("click", handleClickOutHead);
    };
  }, [isOpendrop]);
//dropdown end
  useEffect(()=>{
    getTheReadingRoom();
  },[])
  useEffect(()=>{
    if(theReadingRoomData && theReadingRoomData.readingRoomData){
      setReadingData(theReadingRoomData.readingRoomData);
    }
    if(theReadingRoomData && theReadingRoomData.readingRoomData && theReadingRoomData.readingRoomData.meta){
      setmetaData(theReadingRoomData.readingRoomData.meta);
    }
  },[theReadingRoomData])
  
  useEffect(() => {
    const handleWindowSizeChange = () => {
      setIsDesktop(window.innerWidth > 767);
    };
    window.addEventListener('resize', handleWindowSizeChange);
    handleWindowSizeChange(); // Call the function initially to set the initial state
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);
  const handleClick = (key) => {
    setCardId(key);
    if (cardId == -1 || cardId === key) setShare((prev) => !prev);
    setShare(true);
  };
  const addTodo = () => {
    setShare(false);
  };
  useEffect(() => {
    cornerSectionOverview();
  }, []);

  useEffect(() => {
    if (cornerOverviewList && cornerOverviewList.cornerOverview) {
      setcornerOverviewTab(cornerOverviewList.cornerOverview);
    }
  }, [cornerOverviewList]);

  const storeTitleInCookie = (title) => {
    cookie.save('poemTitle', title, { path: '/' });
  };
  
  return (
    <div className="wrapper">
      {metaData && metaData != null ? (
        <Helmet>
          <title>{metaData && metaData.title ? metaData.title : ""}</title>
          <meta
            name="description"
            content={
              metaData && metaData.description ? metaData.description : ""
            }
          />
          <meta
            name="keywords"
            content={metaData && metaData.keywords ? metaData.keywords : ""}
          />
          <meta
            property="og:title"
            content={metaData && metaData.og_title ? metaData.og_title : ""}
          />
          <meta
            property="og:description"
            content={
              metaData && metaData.og_description ? metaData.og_description : ""
            }
          />
          <meta
            property="og:image"
            content={metaData && metaData.og_image ? metaData.og_image : ""}
          />
          <meta
            property="og:url"
            content={metaData && metaData.og_url ? metaData.og_url : ""}
          />
        </Helmet>
      ) : (
        ""
      )}
      <section className="aboutHead">
        <div className="container">
          <div className="d-flex dropdowncls">
            <div className="dropdown me-auto" ref={dropdownheadRef}>
              <div id="dropdownMenuLink" onClick={toggleDropDownHead}>
                <h1>
                  <span>The Reading</span> Room
                  <img
                    className="ms-2"
                    src="/images/New/redDownArrow.svg"
                    alt="arrow"
                  />
                </h1>
              </div>
              {isOpendrop && (
                <ul
                  className="dropdown-body"
                  aria-labelledby="dropdownMenuLink"
                >
                  {cornerOverviewTab &&
                  cornerOverviewTab.length > 0 &&
                  cornerOverviewTab.map((over, index) =>
                    over.linkName != "The Reading Room" ? (
                      <li>
                        <a
                          class="dropdown-item fw-bold"
                          href={over.linkName=='Quiz' ? over.linkUrl : over.routeConstant}
                        >
                          {over.linkName ? over.linkName : ''}
                        </a>
                      </li>
                    ) : null
                  )}
                </ul>
              )}
            </div>

            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/learners-corner">Learners’ Corner</a>
                </li>
                <li
                  className="breadcrumb-item active breadcolor"
                  aria-current="page"
                >
                  <a href="/learners-corner/the-reading-room">The Reading Room</a>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <div>
        <div className="bookimg">
          {readingData && 
            readingData.blockData && 
            readingData.blockData.bannerUrl ?  
          <>
          <img
            className="d-block w-100 bannerimg"
            src={readingData.blockData.bannerUrl}
          />
          {readingData && 
            readingData.blockData && readingData.blockData.body ?
          <div className="container position">
            <div className="row">
              <div className="col-lg-12">
                <div className="reviewbg">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: readingData.blockData.body,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          :''}
          </>
          :''}
          {readingData && 
            readingData.blockData && 
            readingData.blockData.ReadingSections && 
            readingData.blockData.ReadingSections.cards &&
            readingData.blockData.ReadingSections.cards.length > 0 &&
          <div className="container">
            <div className="todaydiv">
              <h2>{readingData.blockData.ReadingSections.title}</h2>
              <div className="row">
                {readingData && 
                  readingData.blockData && 
                  readingData.blockData.ReadingSections && 
                  readingData.blockData.ReadingSections.cards &&
                  readingData.blockData.ReadingSections.cards.length > 0 &&
                  readingData.blockData.ReadingSections.cards.map((item,index)=>{
                    return(
                      <div className="col-6">
                        <a href={item.linkUrl ? item.linkUrl : ''}>
                          <div className="todaysec h-100">
                            <img src={item.thumbnail && item.thumbnail.url ? item.thumbnail.url : ''} alt={item.thumbnail && item.thumbnail.alt_text ? item.thumbnail.alt_text : ''} className="img-fluid"/>
                            <div>
                              <h3>{item.title ? item.title : ''}</h3>
                              <p>{item.description ? item.description : ''}</p>
                            </div>
                          </div>
                        </a>
                      </div>
                    )
                  })}
              </div>
            </div>
          </div>
          }
          <div className="latestPost">
            <div className="container">
              <h2>Latest Posts</h2>
              <div className="row">
                {readingData && 
                readingData.latestPosts && 
                readingData.latestPosts.length > 0 && 
                readingData.latestPosts.map((item,index)=>{
                  return(
                    <div className="col-md-3">
                      <div className="postdiv">
                        <a href={item.type === "Book Review" ? 
                          `/learners-corner/the-reading-room/book-review-zone/${item.suggestedUrl ? item.suggestedUrl :''}`
                        : `/learners-corner/the-reading-room/poetry-lounge`} className="postimgdiv"
                        onClick={() => storeTitleInCookie(item.title)}>
                          {item.type === "Book Review" ?
                          <>
                          <img src={item.image && item.image.url ? item.image.url : ''} 
                          alt={item.image && item.image.alt ? item.image.alt : ''} 
                          className={`postimg img-fluid ${isDesktop === true ? "bookblur" :""}`}/>
                          {isDesktop === true ? 
                          <img src={item.image && item.image.url ? item.image.url : ''} 
                          alt={item.image && item.image.alt ? item.image.alt : ''} 
                          className="postimg2"/>
                          :''}
                          </>
                          :
                          <img src={item.thumbnail && item.thumbnail.url ? item.thumbnail.url : ''} 
                          alt={item.thumbnail && item.thumbnail.alt ? item.thumbnail.alt : ''} 
                          className="postimg img-fluid"/>}
                        </a>
                        <div className="postright">
                          {isDesktop === true &&
                          <div className="titleview">
                            <p>{item.type ? item.type : ''}</p>
                            {/* <div className="views">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M14.0865 6.56874C14.8596 7.38212 14.8596 8.6179 14.0865 9.43128C12.7827 10.8031 10.5434 12.6667 7.99967 12.6667C5.456 12.6667 3.21667 10.8031 1.91281 9.43128C1.13974 8.6179 1.13974 7.38212 1.91281 6.56874C3.21667 5.1969 5.456 3.33334 7.99967 3.33334C10.5434 3.33334 12.7827 5.1969 14.0865 6.56874Z" stroke="#333333" stroke-width="1.5"/>
                                <path d="M9.99967 8.00001C9.99967 9.10458 9.10424 10 7.99967 10C6.89511 10 5.99967 9.10458 5.99967 8.00001C5.99967 6.89544 6.89511 6.00001 7.99967 6.00001C9.10424 6.00001 9.99967 6.89544 9.99967 8.00001Z" stroke="#333333" stroke-width="1.5"/>
                              </svg>
                              <p>1244</p>
                            </div> */}
                          </div>
                          }
                          <a href={item.type === "Book Review" ? 
                              `/learners-corner/the-reading-room/book-review-zone/${item.suggestedUrl ? item.suggestedUrl : ''}`
                            : `/learners-corner/the-reading-room/poetry-lounge`}
                            onClick={() => storeTitleInCookie(item.title)}>
                            <h3>{item.title ? item.title : ''}</h3>
                          </a>
                          {isDesktop === false &&
                          <div className="titleview">
                            <p>{item.type ? item.type : ''}</p>
                            {/* <div className="views">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M14.0865 6.56874C14.8596 7.38212 14.8596 8.6179 14.0865 9.43128C12.7827 10.8031 10.5434 12.6667 7.99967 12.6667C5.456 12.6667 3.21667 10.8031 1.91281 9.43128C1.13974 8.6179 1.13974 7.38212 1.91281 6.56874C3.21667 5.1969 5.456 3.33334 7.99967 3.33334C10.5434 3.33334 12.7827 5.1969 14.0865 6.56874Z" stroke="#333333" stroke-width="1.5"/>
                                <path d="M9.99967 8.00001C9.99967 9.10458 9.10424 10 7.99967 10C6.89511 10 5.99967 9.10458 5.99967 8.00001C5.99967 6.89544 6.89511 6.00001 7.99967 6.00001C9.10424 6.00001 9.99967 6.89544 9.99967 8.00001Z" stroke="#333333" stroke-width="1.5"/>
                              </svg>
                              <p>1244</p>
                            </div> */}
                          </div>
                          }
                          <div className="sharedwd">
                            <div className="share" onClick={() => handleClick(index)}>
                              <div className="shareimg">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <path d="M8.63117 10.4344C8.05654 9.2874 6.87022 8.5 5.49999 8.5C3.56699 8.5 1.99998 10.067 1.99998 12C1.99998 13.933 3.56699 15.5 5.49999 15.5C6.87022 15.5 8.05654 14.7126 8.63117 13.5656M8.63117 10.4344C8.86717 10.9055 8.99999 11.4372 8.99999 12C8.99999 12.5628 8.86717 13.0945 8.63117 13.5656M8.63117 10.4344L15.3688 7.06559M8.63117 13.5656L15.3688 16.9344M15.3688 7.06559C15.9434 8.2126 17.1298 9 18.5 9C20.433 9 22 7.433 22 5.5C22 3.567 20.433 2 18.5 2C16.567 2 15 3.567 15 5.5C15 6.06276 15.1328 6.59451 15.3688 7.06559ZM15.3688 16.9344C15.1328 17.4055 15 17.9372 15 18.5C15 20.433 16.567 22 18.5 22C20.433 22 22 20.433 22 18.5C22 16.567 20.433 15 18.5 15C17.1298 15 15.9434 15.7874 15.3688 16.9344Z" stroke="#004B8B" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                              </div>
                              {share && cardId === index && (
                                <SocialShare
                                  fundName={getRouting(
                                    `/${item.suggestedUrl}`
                                  )}
                                  addTodo={addTodo}
                                />
                              )}
                            </div>
                            {item.file && item.file.url ?
                            <a href={item.file && item.file.url} className="ms-2">
                              <div className="download">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <path d="M9 12L12 15M12 15L15 12M12 15L12 3" stroke="#004B8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M7.5 9L5.4 9C4.07452 9 3 10.0745 3 11.4L3 18.6C3 19.9255 4.07452 21 5.4 21L18.6 21C19.9255 21 21 19.9255 21 18.6L21 11.4C21 10.0745 19.9255 9 18.6 9H16.5" stroke="#004B8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </div>
                            </a>
                            :''}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
          {readingData && 
            readingData.blockData && 
            readingData.blockData.disclaimer ?
              <div className="container">
                <div className="disclaimersec mb-5">
                  <h2>Disclaimer</h2>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: readingData.blockData.disclaimer,
                    }}
                  />
                </div>
              </div>
          :''}
        </div>
      </div>
    </div>
  );
};


const mapStateToProps = (state) => ({
  theReadingRoomData: state.LearnsCorners,
  cornerOverviewList: state.LearnsCorners,
});

const mapDispatchToProps = (dispatch) => ({
  getTheReadingRoom: bindActionCreators(getTheReadingRoom, dispatch),
  cornerSectionOverview: bindActionCreators(cornerSectionOverview, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TheReadingRoom);
